// presentation/components/Sidebar.tsx
import React, { useState } from "react";
import { Nav, Accordion, Image } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import {
  MAIN_MENUS,
  EVENT_SUBMENUS,
  USER_SUBMENUS,
  COUNSELLING_SUBMENUS,
  SECONDARY_MENUS,
  MENTORING_SUBMENUS,
} from "../../core/mocks/sidebar-mocks";
import ProfileDropDown from "./ProfileDropDown";
import { TbTimelineEventText } from "react-icons/tb";
import { FaUsersCog } from "react-icons/fa";
import { Ecounselling, Ementoring } from "../../presentation/assets";

interface MenuItem {
  name: string;
  icon: React.ReactNode;
  url: string;
  roles?: string[];
}

const Sidebar: React.FC = () => {
  const userRoles = sessionStorage.getItem("roles")?.split(",") || [];

  const [accordionStates, setAccordionStates] = useState({
    events: false,
    users: false,
    counselling: false,
    mentoring: false,
  });

  const toggleAccordion = (key: keyof typeof accordionStates) => {
    setAccordionStates((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  const filterMenuItems = (items: MenuItem[]) => {
    return items.filter(
      (item) =>
        !item.roles || item.roles.some((role) => userRoles.includes(role))
    );
  };

  const renderMenuLink = (item: MenuItem, index: number) => (
    <Nav.Link key={index} as={NavLink} to={item.url} className="mb-2">
      {item.icon}
      <span className="ms-1 px-2 d-sm-inline">{item.name}</span>
    </Nav.Link>
  );

  const renderAccordionMenu = (
    key: keyof typeof accordionStates,
    title: string,
    icon: React.ReactNode,
    items: MenuItem[]
  ) => (
    <Accordion activeKey={accordionStates[key] ? "0" : ""}>
      <Accordion.Item className="border-0 bg-transparent" eventKey="0">
        <Accordion.Header
          className="px-0 m-0 bg-transparent"
          onClick={() => toggleAccordion(key)}
        >
          {icon}
          <span style={{ fontSize: "14px" }} className="ms-1 px-2 d-sm-inline">
            {title}
          </span>
        </Accordion.Header>
        <Accordion.Body>
          <Nav className="flex-column">
            {filterMenuItems(items).map((item, index) =>
              renderMenuLink(item, index)
            )}
          </Nav>
        </Accordion.Body>
      </Accordion.Item>
    </Accordion>
  );

  return (
    <div className="d-flex flex-column py-3" style={{ minHeight: "100%" }}>
      <div>
        <ProfileDropDown />

        <Nav defaultActiveKey="/home" className="flex-column mt-2 sidebar-menu">
          {filterMenuItems(MAIN_MENUS).map((menuItem, index) => {
            if (menuItem.name === "Events") {
              return renderAccordionMenu(
                "events",
                "Event Management",
                <TbTimelineEventText />,
                EVENT_SUBMENUS
              );
            }

            if (menuItem.name === "Users") {
              return renderAccordionMenu(
                "users",
                "User Management",
                <FaUsersCog />,
                USER_SUBMENUS
              );
            }

            if (menuItem.name === "E-counselling") {
              return renderAccordionMenu(
                "counselling",
                "E-Counselling",
                <Image src={Ecounselling} alt="" />,
                COUNSELLING_SUBMENUS
              );
            }

            return renderMenuLink(menuItem, index);
          })}

          <hr className="my-2" />

          {filterMenuItems(SECONDARY_MENUS).map((menuItem, index) => {
            if (menuItem.name === "E-mentoring") {
              return renderAccordionMenu(
                "mentoring",
                "E-Mentoring",
                <Image src={Ementoring} alt="" />,
                MENTORING_SUBMENUS
              );
            }

            return renderMenuLink(menuItem, index);
          })}
        </Nav>
      </div>
    </div>
  );
};

export default Sidebar;
